module.exports = __webpack_public_path__ + "static/media/flower.9f9d89a3.svg";